<template>
    <div>
        <button type="button"
                @click="appendDataToModal"
                style="display: none"
                data-toggle="modal"
                data-target="#description_modal"
                id="model_btn"
        >
        </button>
        <div id="description_modal" class="modal fade rtl" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <div id="tx_title"> {{$t('label.rejected_status_description_title')}} </div>
                        <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                    </div>
                    <div id="data_sheet" class="modal-body mb-4">
                        <kt-row>
                            {{ $t('label.correct_authentication_link_description')}}
                        </kt-row>
                        <kt-row style="text-align: center">
                            <button class="kt-nav__link mt-3 btn btn-secondary"
                                    style="text-align: center"
                                    @click="linkToProfile"
                                    type="button"

                            >
                                <kt-nav-link-icon type="fa" name="lock"></kt-nav-link-icon>
                                <kt-nav-link-text> {{ $t('panel.profile.nav.authentication') }} </kt-nav-link-text>
                            </button>
                        </kt-row>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import { userStatus } from '@/constants/userStatus'
    import {mapGetters} from "vuex";
    import $ from "jquery";
    import { i18n } from '@/plugins/i18n'

    export default {

        data() {
            return {
                userStatus: userStatus
            }
        },
        computed: {
            ...mapGetters('user', [
                'current_user'
            ])
        },
        watch: {
            current_user: function (current_user) {
                if (current_user.status == userStatus.AUTHORIZATION_DOCUMENTS_REJECTED)
                    this.showModal()
            }
        },
        methods: {
            showModal() {
                $('#model_btn').click()
            },
            appendDataToModal() {},
            linkToProfile() {
                $('#description_modal').modal('toggle')
                this.$router.push('/profile/authenticate')
            }
        }
    }
</script>
